import React from "react";
import { Link } from "react-router-dom";  
import Phase from "../cards/Phase";

const ThreePhase = () => {
  return (
    <>
      <section 
        className="home bg-cover bg-center min-h-screen"
        style={{
          backgroundImage: "url('/assets/images/Monitor.jpg')",
        }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10">
          <div className="heading flex flex-col sm:flex-row justify-between items-center mb-6 sm:mb-8">
            <h3 className="text-2xl m:text-8xl font-semibold !text-white drop-shadow text-center sm:text-left">DashBoard</h3>
            <div className="button-group flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 mt-4 sm:mt-0 w-full sm:w-auto">
              <Link 
                to="/singlephase" 
                className="btn px-4 sm:px-6 py-2 sm:py-2 
                  border border-[#005BAC] 
                  bg-[#005BAC] 
                  text-white 
                  rounded-md 
                  transition duration-300 
                  hover:bg-white 
                  hover:text-[#005BAC] 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-[#005BAC] 
                  focus:ring-opacity-50
                  text-center
                  text-sm sm:text-base
                  w-full sm:w-auto"
              >
                Single Phase
              </Link>
              <Link 
                to="/threephase" 
                className="btn px-4 sm:px-6 py-2 sm:py-2 
                  border border-[#005BAC] 
                  bg-[#005BAC] 
                  text-white 
                  rounded-md 
                  transition duration-300 
                  hover:bg-white 
                  hover:text-[#005BAC] 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-[#005BAC] 
                  focus:ring-opacity-50
                  text-center
                  text-sm sm:text-base
                  w-full sm:w-auto"
              >
                Three Phase
              </Link>
            </div>
            
          </div>
          <Phase />
        </div>
      </section>
    </>
  );
};
export default ThreePhase;